/* eslint-disable import/prefer-default-export */

export const getCities = state => state.cities
export const getStates = state => state.states
export const getColonies = state => state.colonies
